module.exports = __webpack_public_path__ + "img/guide05_1.1be760cf.png";